import { ItemsService } from './../../../shared/services/items.service';
import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IItem } from '../../interfaces/IItem';
import { IItemAttribute } from '../../interfaces/model';
import { NgIf, NgFor, NgClass, CommonModule } from '@angular/common';
import { CartService } from '../../cart/cart.service';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-item-attributes',
  templateUrl: './item-attributes.component.html',
  styleUrls: ['./item-attributes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgFor, NgClass, CommonModule]
})
export class ItemAttributesComponent implements OnInit {
  @Input() item: IItem;
  @Input() hideText: boolean;
  @Input() moreThanOnHand: boolean;
  @Input() isCart: boolean;
  @Input() isJustSold: boolean;
  @Input() isNotificationItem: boolean = false;
  @Input() isBuyerOffers: boolean = false;
  @Input({ required: false }) cartItemId?: string;

  environment = environment;
  attributes: IItemAttribute[];

  next = false;
  previous = false;
  etaFromPrevious?: string;
  etaToPrevious?: string;

  constructor(
    private cdr: ChangeDetectorRef,
    private cartService: CartService,
    private router: Router,
    public itemsService: ItemsService,
  ) {  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
       this.cartService.cartListPrevious = [];
      }
    });

    this.getVisibleAttributes();
    if (this.isCart) { this.setPreviousEta(); }
    
    setTimeout(() => {
      this.setEtaTransition();
    }, 0);

  }


  getVisibleAttributes(): void {
    this.attributes = this.item.attributes?.filter(a => !a.hide);
  }

  setPreviousEta() {
    this.etaFromPrevious = this.item?.etaFrom;
    this.etaToPrevious = this.item?.etaTo;
    const previousCartItem = this.cartService.cartListPrevious?.find(cartItem => cartItem.id === this.cartItemId);
    if (previousCartItem) {
      this.etaFromPrevious = previousCartItem.item?.etaFrom;
      this.etaToPrevious = previousCartItem.item?.etaTo;
    }
  }

  setEtaTransition() {
    const etaFromDate = this.item?.etaFrom ? new Date(this.item.etaFrom) : null;
    const etaFromPreviousDate = this.etaFromPrevious ? new Date(this.etaFromPrevious) : null;

    if (
      !etaFromDate || isNaN(etaFromDate.getTime()) ||
      !etaFromPreviousDate || isNaN(etaFromPreviousDate.getTime())
    ) {
      this.next = false;
      this.previous = false;
    } else if (etaFromDate > etaFromPreviousDate) {
      this.next = true;
      this.previous = false;
    } else if (etaFromDate < etaFromPreviousDate) {
      this.next = false;
      this.previous = true;
    } else {
      this.next = false;
      this.previous = false;
    }

    this.cdr.markForCheck();
  }

}
